// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8701dc61","516":"c5393d6a","656":"e279c74f"}[chunkId] + ".chunk.js";
};